import { create } from "zustand";

interface SupportState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * Open state of the in-app Help dialog. Store-driven so the trigger can live
 * in `BrandActions` (rendered twice on desktop: sidebar + overlay aside) while
 * `<SupportDialog />` is mounted exactly once per shell.
 */
export const useSupportStore = create<SupportState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
